import styled from '@emotion/styled';
import React from 'react';
import { Input } from 'antd';

const StyledInput = styled(Input)`
    width: 62px;
    height: 32px;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    appearance: textfield;
    border-radius: 0.375rem;
`;

interface IProps {
    labelFirst: string;
    labelSecond: string;
    valueFirst: string;
    valueSecond: string;
    onChangeFirst: (value: string) => void;
    onChangeSecond: (value: string) => void;
    placeholderFirst?: string;
    placeholderSecond?: string;
    classNameFirst: string;
    classNameSecond: string;
    containerClassName?: string;
    firstGroupClassName?: string;
    isRequired?: boolean;
    testIdContainer?: string;
    testIdFirst?: string;
    testIdSecond?: string;
}

const CombinedInput = (props: IProps) => {
    const {
        labelFirst,
        labelSecond,
        valueFirst,
        valueSecond,
        onChangeFirst,
        onChangeSecond,
        placeholderFirst,
        placeholderSecond,
        classNameFirst,
        classNameSecond,
        containerClassName,
        firstGroupClassName,
        isRequired,
        testIdContainer,
        testIdFirst,
        testIdSecond,
    } = props;
    return (
        <div className={`flex gap-2 ${containerClassName || ''}`} data-testid={testIdContainer}>
            <div className={`flex gap-4 items-center ${firstGroupClassName || ''}`}>
                <label>{labelFirst}:</label>
                <StyledInput
                    data-testid={testIdFirst}
                    value={valueFirst}
                    onChange={(e) => onChangeFirst(e.target.value)}
                    placeholder={placeholderFirst || ''}
                    className={classNameFirst}
                />
            </div>
            <div className="flex gap-2 items-center">
                <label>{labelSecond}:</label>
                <StyledInput
                    data-testid={testIdSecond}
                    value={valueSecond}
                    onChange={(e) => onChangeSecond(e.target.value)}
                    placeholder={placeholderSecond || ''}
                    className={classNameSecond}
                />
            </div>
        </div>
    );
};

export default CombinedInput;
